import * as actionConst from './actions';

const initialStage = {
    currentUser: {},
    currentWasteSlipRequester: {}
}

export default function (state = initialStage, action) {
    switch (action.type) {
        case actionConst.SET_USER:
            return {
                ...state,
                currentUser: action.payload
            };
        case actionConst.SET_WASTE_SLIP_REQUESTER:
            return {
                ...state,
                currentWasteSlipRequester: action.payload
            };
        default:
            return state;
    }
}
